<div
    [id]="id()"
    [attr.data-testId]="currentTestId()"
    [attr.data-styleTarget]="id()"
    [attr.data-uiTarget]="'card-grid'"
    class="rounded-md p-4 dat-border-card grid grid-cols-1 gap-y-2 md:grid-cols-3 md:gap-x-4 md:gap-y-4 font-body-1"
>
    @for (projectKey of projectKeys; track $index) {
    <iq-status-library-card [projectKey]="projectKey"></iq-status-library-card>
    } @if(maxCards() < allProjectKeys.length){
    <button
        [attr.data-uiTarget]="'load-more'"
        class="rounded-full p-2 bg-dat-blue-500 text-white col-span-1 md:col-span-3"
        (click)="loadMore()"
    >
        Add More Cards
    </button>
    }
</div>
